export const shouldUseUnifiedSportEventsTable = (_sportId: string, featureEnabled: boolean): boolean => {
    if (featureEnabled) {
        return true;
    }

    return false;
};
